import React from 'react';

export const FAInfoIcon = ({ width = 11, height = 10, color = '#CBD5E1' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 11 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.23438 10C3.4375 10 1.79688 9.0625 0.898438 7.5C0 5.95703 0 4.0625 0.898438 2.5C1.79688 0.957031 3.4375 0 5.23438 0C7.01172 0 8.65234 0.957031 9.55078 2.5C10.4492 4.0625 10.4492 5.95703 9.55078 7.5C8.65234 9.0625 7.01172 10 5.23438 10ZM4.45312 6.5625C4.17969 6.5625 3.98438 6.77734 3.98438 7.03125C3.98438 7.30469 4.17969 7.5 4.45312 7.5H6.01562C6.26953 7.5 6.48438 7.30469 6.48438 7.03125C6.48438 6.77734 6.26953 6.5625 6.01562 6.5625H5.85938V4.84375C5.85938 4.58984 5.64453 4.375 5.39062 4.375H4.45312C4.17969 4.375 3.98438 4.58984 3.98438 4.84375C3.98438 5.11719 4.17969 5.3125 4.45312 5.3125H4.92188V6.5625H4.45312ZM5.23438 2.5C4.88281 2.5 4.60938 2.79297 4.60938 3.125C4.60938 3.47656 4.88281 3.75 5.23438 3.75C5.56641 3.75 5.85938 3.47656 5.85938 3.125C5.85938 2.79297 5.56641 2.5 5.23438 2.5Z"
        fill={color}
      />
    </svg>
  );
};

export default FAInfoIcon;
